import React from 'react';
import api from '../api/axios';
import { Button, Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import posthog from 'posthog-js';
import { ReactComponent as AppleIcon } from '../assets/images/apple.svg';
import { ReactComponent as AppleDark } from '../assets/images/apple-dark.svg';
import { ReactComponent as GoogleIcon } from '../assets/images/google.svg';
import { ReactComponent as MicrosoftIcon } from '../assets/images/microsoft.svg';

const OAuthComponents = () => {
  const theme = useTheme();
  const AppleLogo = () =>
    theme.palette.mode === 'dark' ? (
      <AppleIcon
        alt="Apple"
        style={{
          width: theme.breakpoints.values.xs ? 24 : 30,
          height: theme.breakpoints.values.xs ? 24 : 30,
        }}
      />
    ) : (
      <AppleDark
        alt="Apple"
        style={{
          width: theme.breakpoints.values.xs ? 24 : 30,
          height: theme.breakpoints.values.xs ? 24 : 30,
        }}
      />
    );
  const GoogleLogo = () => (
    <GoogleIcon
      alt="Google"
      style={{
        width: theme.breakpoints.values.xs ? 24 : 30,
        height: theme.breakpoints.values.xs ? 24 : 30,
      }}
    />
  );
  const MicrosoftLogo = () => (
    <MicrosoftIcon
      alt="Microsoft"
      style={{
        width: theme.breakpoints.values.xs ? 24 : 30,
        height: theme.breakpoints.values.xs ? 24 : 30,
      }}
    />
  );
  return (
    <Stack
      flexDirection="column"
      alignItems="center"
      spacing={{ xs: 2, sm: 3 }}
      sx={{ width: '100%' }}
    >
      {/* <IconButton
        variant="contained"
        startIcon={<AppleLogo />}
        onClick={() => (window.location.href = `${api}/auth/apple`)}
      >
        Continue with Apple
      </IconButton> */}
      <IconButton
        variant="contained"
        startIcon={<GoogleLogo />}
        onClick={() => {
          posthog.capture('oauth_initiated', { provider: 'google' });
          window.location.href = `${api}/auth/google`;
        }}
      >
        Continue with Google
      </IconButton>
      <IconButton
        variant="contained"
        startIcon={<MicrosoftLogo />}
        onClick={() => {
          posthog.capture('oauth_initiated', { provider: 'microsoft' });
          window.location.href = `${api}/auth/microsoft`;
        }}
      >
        Continue with Microsoft
      </IconButton>
    </Stack>
  );
};

const IconButton = styled(Button)(({ theme }) => ({
  border: '2px solid #bababa',
  borderRadius: '6px',
  boxShadow: 'none',
  textTransform: 'none',
  justifyContent: 'flex-start',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? '#454545' : '#f7f7f7',
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1.5),
  },

  height: '61px',
  width: '387px',
  fontSize: '24px',
  paddingLeft: '40px',
  marginBottom: '40px',

  [theme.breakpoints.down('md')]: {
    width: '320px',
    height: '55px',
    fontSize: '20px',
    paddingLeft: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%', // take most of screen width
    height: '48px',
    fontSize: '16px',
    paddingLeft: '20px',
  },
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    fontSize: '14px',
    paddingLeft: '16px',
  },
}));

export default OAuthComponents;
